import { shortenString } from '@weft/utils';

const DEFAULT_SHORTEN_LENGTH = 5;

export function shortenInvoiceId(id: string) {
  return shortenString(id, DEFAULT_SHORTEN_LENGTH);
}